import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet-async'
import yn from 'yn'

import favicon from '@loyal/favicon.ico'

const HeadMetadata = ({ title, description, keywords }) => (
  <Helmet>
    <title>{title}</title>

    {yn(process.env.REACT_APP_NO_INDEX) && (
      <meta name='robots' content='noindex, nofollow' />
    )}

    <link rel='shortcut icon' href={favicon} />

    <meta name='author' content='Grupo LTM' />
    <meta
      name='description'
      content={description}
    />
    <meta name='keywords' content={keywords} />

    <meta httpEquiv='pragma' content='no-cache' />
    <meta httpEquiv='expires' content='-1' />

    <meta itemProp='name' content='WebPrêmios' />
    <meta itemProp='image' content='' />
    <meta itemProp='url' content='https://webpremios.com.br' />
    <meta
      itemProp='description'
      content='O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.'
    />

    <meta property='og:title' content='WebPrêmios' />
    <meta property='og:image' content='' />
    <meta property='og:url' content='https://webpremios.com.br' />
    <meta property='og:type' content='website' />
    <meta
      property='og:description'
      content='O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.'
    />
  </Helmet>
)

HeadMetadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string
}

export default HeadMetadata



// WEBPACK FOOTER //
// ./src/Shared/HeadMetadata/HeadMetadata.js